export default [
  {
    path: '/database-tables/:databaseConfigId/:databaseName',
    name: 'DatabaseTables',
    component: () => import("@/views/Page/DatabaseTables/DatabaseTables.vue"),
    meta: {
      title: '#Default# | Database Tables',
    },
  }
];
